unit Search.XFuelsDepots;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  XData.Web.Client;

type
  TfrmSearchXFuels = class(TWebForm)
    WebPanel1: TWebPanel;
    WebPanel2: TWebPanel;
    WebPanel3: TWebPanel;
    WebButton1: TWebButton;
    WebButton2: TWebButton;
    weSearch: TWebEdit;
    dgSearch: TTMSFNCDataGrid;
    dgdbaSearch: TTMSFNCDataGridDatabaseAdapter;
    wcSearch: TXDataWebClient;
    wdsSearch: TXDataWebDataSet;
    dsSearch: TWebDataSource;
    wdsSearchdepotcode: TIntegerField;
    wdsSearchdepotname: TStringField;
    procedure dgSearchCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure weSearchChange(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    iXFuelsDepotcode : Integer;
    sXFuelsDepotName : String;
  end;

var
  frmSearchXFuels: TfrmSearchXFuels;

implementation

{$R *.dfm}
uses
  stfmssystem.connection;

procedure TfrmSearchXFuels.dgSearchCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  dgdbaSearch.SetActiveRecord(ARow);
  iXFuelsDepotcode := dgdbaSearch.FieldAtColumn[0].AsInteger;
  sXFuelsDepotName := dgdbaSearch.FieldAtColumn[1].AsString;
end;

procedure TfrmSearchXFuels.WebButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmSearchXFuels.WebButton2Click(Sender: TObject);
begin
  iXFuelsDepotcode := -1;
  sXFuelsDepotName := '';
end;

procedure TfrmSearchXFuels.WebFormShow(Sender: TObject);

    procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsSearch.Close;
      wdsSearch.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSearch.Open;
    end;

begin
  wcSearch.RawInvoke('IstfmsdieselService.Get_XFuelDepots_View',[],@OnSuccess,@OnError);
end;

procedure TfrmSearchXFuels.weSearchChange(Sender: TObject);
begin
  if weSearch.Text <> '' then
    begin
      case dgSearch.Selection.StartCell.Column of
        0 : wdsSearch.Locate('depotcode', weSearch.Text, [loPartialKey]);
        1 : wdsSearch.Locate('depotname', weSearch.Text, [loPartialKey]);
      end;
    end;
end;

end.